

// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import ReactMarkdown from 'react-markdown';
// import gfm from 'remark-gfm';
// import axios from 'axios';
// import Snackbar from '@material-ui/core/Snackbar';
// import MuiAlert from '@material-ui/lab/Alert';
// import Navbar from './Navbar'; // Import the Navbar component

// function Alert(props) {
//   return <MuiAlert elevation={6} variant="filled" {...props} />;
// }

// const Chatbot = () => {
//   const navigate = useNavigate(); // Initialize useNavigate
//   const [messages, setMessages] = useState([
//     { text: "Hi, I am your Sales Coach. Please include Name, Contact, Industry and Opportunity name in your query", sender: 'bot' }
//   ]);
//   const [inputValue, setInputValue] = useState("");
//   const [isSending, setIsSending] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [activeButton, setActiveButton] = useState(""); // New state for active button
//   const [opportunities, setOpportunities] = useState(0); // State for number of opportunities
//   const messagesEndRef = useRef(null);
//   const inputRef = useRef(null);

//   useEffect(() => {
//     scrollToBottom();
//   }, [messages]);

//   useEffect(() => {
//     if (inputRef.current) {
//       inputRef.current.focus();
//     }
//   }, [messages]);

//   useEffect(() => {
//     fetchOpportunities();
//   }, []);

//   const scrollToBottom = () => {
//     messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//   };
//   const handleNavbarFileUpload = async (file) => {
//     if (file) {
//       const userId = sessionStorage.getItem('user_id');
//       if (!userId) {
//         setSnackbarMessage('User ID not found. Please log in again.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         return;
//       }

//       const formData = new FormData();
//       formData.append('file', file);
//       formData.append('user_id', userId);

//       console.log("File upload request:", {
//         url: `http://localhost:8000/upload`,
//         data: formData,
//       });

//       try {
//         await axios.post(`http://localhost:8000/upload`, formData, {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//           },
//         });

//         setSnackbarSeverity('success');
//         setSnackbarMessage('File uploaded successfully');
//         setMessages([...messages, { text: `Uploaded file: ${file.name}`, sender: 'user' }]);
//       } catch (error) {
//         setSnackbarSeverity('error');
//         setSnackbarMessage('Failed to upload file');
//         console.error('Error uploading file:', error);
//       } finally {
//         setSnackbarOpen(true);
//       }
//     }
//   };

//   const fetchOpportunities = async () => {
//     const userId = sessionStorage.getItem('user_id');
//     if (!userId) {
//       setSnackbarMessage('User ID not found. Please log in again.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//       return;
//     }

//     try {
//       const response = await axios.get(`http://localhost:8000/no-of-opportunities?user_id=${userId}`);
//       setOpportunities(response.data['no-of-opportunities']);
//     } catch (error) {
//       console.error('Error fetching number of opportunities:', error);
//     }
//   };

//   const handleSendMessage = async () => {
//     if (!activeButton) {
//       setSnackbarMessage('Please select any button to proceed.');
//       setSnackbarSeverity('warning');
//       setSnackbarOpen(true);
//       return;
//     }

//     if (inputValue.trim()) {
//       const userId = sessionStorage.getItem('user_id');
//       if (!userId) {
//         setSnackbarMessage('User ID not found. Please log in again.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         return;
//       }

//       setMessages([...messages, { text: inputValue, sender: 'user' }]);
//       setInputValue("");
//       setIsSending(true);
//       setIsLoading(true);

//       const messagePayload = {
//         user_id: userId,
//         user_query: inputValue,
//         button_str: activeButton, // Include the active button name
//       };

//       console.log("Message sent to backend:", messagePayload);

//       try {
//         const response = await axios.post('http://localhost:8000/prompt-chat', messagePayload);

//         // const { response: botResponse, customer_name: customerName } = response.data;
//         const { response: botResponse } = response.data;

//         setMessages((prevMessages) => [
//           ...prevMessages,
//           { text: botResponse, sender: 'bot' },
//           // { text: `Customer name: ${customerName}`, sender: 'bot' },
//         ]);

//         // Fetch the updated number of opportunities after receiving the response
//         fetchOpportunities();

//       } catch (error) {
//         console.error('Error sending message:', error);
//         setMessages((prevMessages) => [
//           ...prevMessages,
//           { text: 'Sorry, something went wrong. Please try again.', sender: 'bot' },
//         ]);
//       } finally {
//         setIsSending(false);
//         setIsLoading(false);
//       }
//     }
//   };

//   const handleInputChange = (e) => {
//     setInputValue(e.target.value);
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter' && !e.shiftKey) {
//       e.preventDefault();
//       handleSendMessage();
//     }
//   };

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const userId = sessionStorage.getItem('user_id');
//       if (!userId) {
//         setSnackbarMessage('User ID not found. Please log in again.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         return;
//       }

//       const formData = new FormData();
//       formData.append('file', file);
//       formData.append('user_id', userId);

//       console.log("File upload request:", {
//         url: `http://localhost:8000/upload`,
//         data: formData,
//       });

//       try {
//         // const response = await axios.post(`http://localhost:8000/upload`, formData, {
//         await axios.post(`http://localhost:8000/upload`, formData, {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//           },
//         });

//         setSnackbarSeverity('success');
//         setSnackbarMessage('File uploaded successfully');
//         setMessages([...messages, { text: `Uploaded file: ${file.name}`, sender: 'user' }]);
//       } catch (error) {
//         setSnackbarSeverity('error');
//         setSnackbarMessage('Failed to upload file');
//         console.error('Error uploading file:', error);
//       } finally {
//         setSnackbarOpen(true);
//       }
//     }
//   };

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === 'clickaway') {
//       return;
//     }
//     setSnackbarOpen(false);
//   };

//   const handleNavbarButtonClick = (buttonName) => {
//     if (buttonName === 'Log out') {
//       sessionStorage.removeItem('user_id');
//       setSnackbarMessage('Logged out successfully');
//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//       setTimeout(() => {
//         navigate('/'); // Redirect to login page
//       }, 1000); // Wait for 1 second before redirecting
//     } else {
//       setActiveButton(buttonName);
//     }
//   };

//   const pageStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     height: '100vh',
//     background: '#000428',
//     color: '#fff',
//     fontFamily: 'Arial, sans-serif',
//     margin: 0,
//     padding: 0,
//     boxSizing: 'border-box',
//     position: 'relative',
//   };

//   const containerStyle = {
//     flex: 1,
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'flex-end',
//     alignItems: 'center',
//     background: '#000428',
//     width: '100%',
//     paddingTop: '18px',
//     paddingBottom: '18px',
//     boxSizing: 'border-box',
//     filter: isLoading ? 'blur(5px)' : 'none',
//     transition: 'filter 0.3s',
//     overflow: 'auto'
//   };

//   const messagesContainerStyle = {
//     overflow: 'auto',
//     flex: 1,
//     width: '100%',
//     display: 'flex',
//     flexDirection: 'column',
//     paddingTop: '30px',
//     paddingRight: '40px',
//     paddingLeft: '40px',
//     boxSizing: 'border-box',
//     marginTop: '67px', // Adjust for navbar height
//   };

//   const inputContainerStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     width: 'calc(100% - 200px)',
//     padding: '10px',
//     borderTop: '1px solid #333',
//     background: 'transparent',
//   };

//   const inputStyle = {
//     flex: 1,
//     padding: '10px',
//     border: '1px solid #333',
//     borderRadius: '5px',
//     background: 'transparent',
//     color: '#fff',
//     boxSizing: 'border-box',
//   };

//   const buttonStyle = {
//     padding: '10px',
//     border: 'none',
//     borderRadius: '5px',
//     background: 'none',
//     cursor: 'pointer',
//     marginLeft: '10px',
//   };

//   const clipButtonStyle = {
//     padding: '10px',
//     border: 'none',
//     borderRadius: '5px',
//     background: 'none',
//     cursor: 'pointer',
//     marginRight: '10px',
//   };

//   const messageContainerStyle = (sender) => ({
//     display: 'flex',
//     justifyContent: sender === 'user' ? 'flex-end' : 'flex-start',
//     alignItems: 'center',
//     width: '100%',
//     margin: '5px 0',
//   });

//   const messageStyle = (sender) => ({
//     background: sender === 'user' ? '#4a4a4a' : '#333',
//     padding: '10px',
//     borderRadius: '10px',
//     maxWidth: '80%',
//     wordWrap: 'break-word',
//     whiteSpace: 'pre-wrap',
//     display: 'block',
//     alignItems: 'center',
//   });

//   const botLogoStyle = {
//     marginRight: '10px',
//     width: '30px',
//     height: '30px',
//   };

//   const userLogoStyle = {
//     marginLeft: '10px',
//     width: '30px',
//     height: '30px',
//   };

//   const renderMessages = () => {
//     return messages.map((msg, index) => (
//       <div key={index} style={messageContainerStyle(msg.sender)}>
//         {msg.sender === 'bot' && <img src="/images/profilePhoto.png" alt="Bot Logo" style={botLogoStyle} />}
//         <div style={messageStyle(msg.sender)}>
//           <ReactMarkdown remarkPlugins={[gfm]}>{msg.text}</ReactMarkdown>
//         </div>
//         {msg.sender === 'user' && <img src="/images/userProfile.png" alt="User Logo" style={userLogoStyle} />}
//       </div>
//     ));
//   };

//   const opportunitiesStyle = {
//     position: 'absolute',
//     top: '90px', // Adjust based on your layout
//     left: '20px',
//     width: '173px',
//     fontSize: '12px',
//     fontFamily: 'Inter',
//     fontWeight: 500,
//     height: '26px',
//     borderRadius: '4px 0px 0px 0px',
//     background: '#ffffff1a',
//     color: '#fff',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center'
//   };

//   return (
//     <div style={pageStyle}>
//      <Navbar 
//         onButtonClick={handleNavbarButtonClick} 
//         onFileUpload={handleNavbarFileUpload} 
//       /> {/* Include Navbar component */}
//       <div style={opportunitiesStyle}>
//         No of opportunities: {opportunities}
//       </div>
//       {isLoading && (
//         <div className="loading-overlay">
//           <div className="loading-spinner"></div>
//         </div>
//       )}
//       <div style={containerStyle}>
//         <div style={messagesContainerStyle}>
//           {renderMessages()}
//           <div ref={messagesEndRef} />
//         </div>
//         <div style={inputContainerStyle}>
//           <input
//             type="file"
//             id="file-upload"
//             style={{ display: 'none' }}
//             onChange={handleFileChange}
//           />
//           <button style={clipButtonStyle} onClick={() => document.getElementById('file-upload').click()}>
//             <img src="/images/clip.png" alt="Clip" style={{ width: '30px', height: '30px' }} />
//           </button>
//           <input
//             type="text"
//             placeholder="Ask any question..."
//             value={inputValue}
//             onChange={handleInputChange}
//             onKeyPress={handleKeyPress}
//             style={inputStyle}
//             ref={inputRef}
//           />
//           <button onClick={handleSendMessage} style={buttonStyle} disabled={isSending || isLoading}>
//             <img src="/images/send.png" alt="Send" style={{ width: '30px', height: '30px' }} />
//           </button>
//         </div>
//       </div>
//       <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
//         <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </div>
//   );
// };

// export default Chatbot;

// // CSS for loading spinner and overlay
// const loadingOverlayStyle = {
//   position: 'fixed',
//   top: 0,
//   left: 0,
//   width: '100%',
//   height: '100%',
//   backgroundColor: 'rgba(0, 0, 0, 0.5)',
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   zIndex: 1000,
// };

// const loadingSpinnerStyle = {
//   width: '50px',
//   height: '50px',
//   border: '5px solid rgba(255, 255, 255, 0.3)',
//   borderTop: '5px solid #fff',
//   borderRadius: '50%',
//   animation: 'spin 1s linear infinite',
// };

// const styles = document.createElement('style');
// styles.innerHTML = `
//   @keyframes spin {
//     0% { transform: rotate(0deg); }
//     100% { transform: rotate(360deg); }
//   }

//   .loading-overlay {
//     ${Object.entries(loadingOverlayStyle).map(([key, value]) => key + ': ' + value + ';').join(' ')}
//   }

//   .loading-spinner {
//     ${Object.entries(loadingSpinnerStyle).map(([key, value]) => key + ': ' + value + ';').join(' ')}
//   }

//   @media (max-width: 600px) {
//     .pageStyle {
//       padding: 14px 10px;
//     }
//     .inputContainerStyle {
//       width: calc(100% - 20px);
//     }
//     .buttonStyle {
//       margin-left: 5px;
//     }
//   }
// `;

// document.head.appendChild(styles);



//axios instacne 
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import axiosInstance8000 from '../services/8000AxiosInstance'; // Import the 8000 axios instance
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Navbar from './Navbar'; // Import the Navbar component

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Chatbot = () => {
  const navigate = useNavigate(); // Initialize useNavigate
  const [messages, setMessages] = useState([
    { text: "Hi, I am your Sales Coach. Please select one of the buttons above. Start your query with the customer's name and include the following details: Customer contact information, Opportunity name, Contextual details. This will help me assist you better.", sender: 'bot' }
  ]);
  const [inputValue, setInputValue] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [activeButton, setActiveButton] = useState(""); // New state for active button
  const [opportunities, setOpportunities] = useState(0); // State for number of opportunities
  const [customerNames, setCustomerNames] = useState([]);
  const [opportunityNames, setOpportunityNames] = useState([]);
  const [promptIndex, setPromptIndex] = useState(0); // State to track the current prompt index
  const [collectedData, setCollectedData] = useState({
    customer_name: "",
    industry: "",
    opportunity_name: "",
    persona: "",
    sales_stage: "",
    start_date: ""
  }); // State to collect data step by step
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  const initialPrompts = [
    "Please provide the Customer Name:",
    "Please provide the Industry:",
    "Please provide the Opportunity Name or create one:",
    "Please provide the Persona:",
    "Please provide the Sales Stage:",
    "Please provide the Start Date:"
  ];

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [messages]);

  useEffect(() => {
    fetchOpportunities();
  }, []);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleNavbarFileUpload = async (file) => {
    if (file) {
      const userId = sessionStorage.getItem('user_id');
      if (!userId) {
        setSnackbarMessage('User ID not found. Please log in again.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        return;
      }

      const formData = new FormData();
      formData.append('file', file);
      formData.append('user_id', userId);

      console.log("File upload request:", {
        url: `http://localhost:8000/upload/`,
        data: formData,
      });

      try {
        await axiosInstance8000.post('/upload/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        setSnackbarSeverity('success');
        setSnackbarMessage('File uploaded successfully');
        setMessages([...messages, { text: `Uploaded file: ${file.name}`, sender: 'user' }]);
      } catch (error) {
        setSnackbarSeverity('error');
        setSnackbarMessage('Failed to upload file');
        console.error('Error uploading file:', error);
      } finally {
        setSnackbarOpen(true);
      }
    }
  };

  const fetchOpportunities = async () => {
    const userId = sessionStorage.getItem('user_id');
    if (!userId) {
      setSnackbarMessage('User ID not found. Please log in again.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    try {
      const response = await axiosInstance8000.get(`/no-of-opportunities?user_id=${userId}`);
      const { 'no-of-opportunities': noOfOpportunities, customer_names: customerNames, opportunity_names: opportunityNames } = response.data;
      setOpportunities(noOfOpportunities);
      setCustomerNames(customerNames);
      setOpportunityNames(opportunityNames);
    } catch (error) {
      console.error('Error fetching number of opportunities:', error);
    }
  };

  const handleSendMessage = async () => {
    if (!activeButton) {
      setSnackbarMessage('Please select any button to proceed.');
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
      return;
    }
  
    if (inputValue.trim()) {
      if (promptIndex < initialPrompts.length) {
        const currentPrompt = initialPrompts[promptIndex];
        const field = currentPrompt.toLowerCase().replace(/ /g, "_").replace(":", "");
        setCollectedData({ ...collectedData, [field]: inputValue });
        setMessages([...messages, { text: inputValue, sender: 'user' }]);
        setInputValue("");
        setPromptIndex(promptIndex + 1);
  
        if (promptIndex + 1 < initialPrompts.length) {
          setMessages((prevMessages) => [
            ...prevMessages,
            { text: initialPrompts[promptIndex + 1], sender: 'bot' },
          ]);
        }
        return;
      }
  
      const userId = sessionStorage.getItem('user_id');
      const apiKey = sessionStorage.getItem('api_key');
      if (!userId || !apiKey) {
        setSnackbarMessage('User ID or API key not found. Please log in again.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        return;
      }
  
      setMessages([...messages, { text: inputValue, sender: 'user' }]);
      setInputValue("");
      setIsSending(true);
      setIsLoading(true);
  
      const messagePayload = {
        user_id: userId,
        user_query: inputValue,
        button_str: activeButton,
        api_key: apiKey,
        collected_data: {
          "Please provide the Customer Name:": collectedData.please_provide_the_customer_name || "",
          "Please provide the Industry:": collectedData.please_provide_the_industry || "",
          "Please provide the Opportunity Name or create one:": collectedData.please_provide_the_opportunity_name_or_create_one || "",
          "Please provide the Persona:": collectedData.please_provide_the_persona || "",
          "Please provide the Sales Stage:": collectedData.please_provide_the_sales_stage || "",
          "Please provide the Start Date:": collectedData.please_provide_the_start_date || "",
        },
      };
  
      console.log("Message sent to backend:", messagePayload);
  
      try {
        const response = await axiosInstance8000.post(`/prompt-chat`, messagePayload, {
          headers: {
            'Authorization': `Bearer ${apiKey}`
          }
        });
  
        const { response: botResponse } = response.data;
  
        setMessages((prevMessages) => [
          ...prevMessages,
          { text: botResponse, sender: 'bot' },
        ]);
  
        fetchOpportunities();
  
      } catch (error) {
        console.error('Error sending message:', error);
        setMessages((prevMessages) => [
          ...prevMessages,
          { text: 'Sorry, something went wrong. Please try again.', sender: 'bot' },
        ]);
      } finally {
        setIsSending(false);
        setIsLoading(false);
      }
    }
  };
  


  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const userId = sessionStorage.getItem('user_id');
      if (!userId) {
        setSnackbarMessage('User ID not found. Please log in again.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        return;
      }

      const formData = new FormData();
      formData.append('file', file);
      formData.append('user_id', userId);

      console.log("File upload request:", {
        url: `http://localhost:8000/upload/`,
        data: formData,
      });

      try {
        await axiosInstance8000.post('/upload/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        setSnackbarSeverity('success');
        setSnackbarMessage('File uploaded successfully');
        setMessages([...messages, { text: `Uploaded file: ${file.name}`, sender: 'user' }]);
      } catch (error) {
        setSnackbarSeverity('error');
        setSnackbarMessage('Failed to upload file');
        console.error('Error uploading file:', error);
      } finally {
        setSnackbarOpen(true);
      }
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleNavbarButtonClick = (buttonName) => {
    if (buttonName === 'Log out') {
      sessionStorage.removeItem('user_id');
      setSnackbarMessage('Logged out successfully');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      setTimeout(() => {
        navigate('/'); // Redirect to login page
      }, 1000); // Wait for 1 second before redirecting
    } else {
      setActiveButton(buttonName);
      setPromptIndex(0); // Reset the prompt index
      setCollectedData({
        customer_name: "",
        industry: "",
        opportunity_name: "",
        persona: "",
        sales_stage: "",
        start_date: ""
      }); // Reset the collected data
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: initialPrompts[0], sender: 'bot' },
      ]);
    }
  };

  const pageStyle = {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    background: '#000428',
    color: '#fff',
    fontFamily: 'Arial, sans-serif',
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    position: 'relative',
  };

  const containerStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center',
    background: '#000428',
    width: '100%',
    paddingTop: '18px',
    paddingBottom: '18px',
    boxSizing: 'border-box',
    filter: isLoading ? 'blur(5px)' : 'none',
    transition: 'filter 0.3s',
    overflow: 'auto'
  };

  const messagesContainerStyle = {
    overflow: 'auto',
    flex: 1,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '30px',
    paddingRight: '40px',
    paddingLeft: '40px',
    boxSizing: 'border-box',
    marginTop: '67px', // Adjust for navbar height
  };

  const inputContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    width: 'calc(100% - 200px)',
    padding: '10px',
    borderTop: '1px solid #333',
    background: 'transparent',
  };

  const inputStyle = {
    flex: 1,
    padding: '10px',
    border: '1px solid #333',
    borderRadius: '5px',
    background: 'transparent',
    color: '#fff',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    padding: '10px',
    border: 'none',
    borderRadius: '5px',
    background: 'none',
    cursor: 'pointer',
    marginLeft: '10px',
  };

  const clipButtonStyle = {
    padding: '10px',
    border: 'none',
    borderRadius: '5px',
    background: 'none',
    cursor: 'pointer',
    marginRight: '10px',
  };

  const messageContainerStyle = (sender) => ({
    display: 'flex',
    justifyContent: sender === 'user' ? 'flex-end' : 'flex-start',
    alignItems: 'center',
    width: '100%',
    margin: '5px 0',
  });

  const messageStyle = (sender) => ({
    background: sender === 'user' ? '#4a4a4a' : '#333',
    padding: '10px',
    borderRadius: '10px',
    maxWidth: '80%',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    display: 'block',
    alignItems: 'center',
  });

  const botLogoStyle = {
    marginRight: '10px',
    width: '30px',
    height: '30px',
  };

  const userLogoStyle = {
    marginLeft: '10px',
    width: '30px',
    height: '30px',
  };

  const renderMessages = () => {
    return messages.map((msg, index) => (
      <div key={index} style={messageContainerStyle(msg.sender)}>
        {msg.sender === 'bot' && <img src="/images/profilePhoto.png" alt="Bot Logo" style={botLogoStyle} />}
        <div style={messageStyle(msg.sender)}>
          <ReactMarkdown remarkPlugins={[gfm]}>{msg.text}</ReactMarkdown>
        </div>
        {msg.sender === 'user' && <img src="/images/userProfile.png" alt="User Logo" style={userLogoStyle} />}
      </div>
    ));
  };

  const opportunitiesStyle = {
    position: 'absolute',
    top: '90px', // Adjust based on your layout
    left: '20px',
    width: '300px', // Increased width
    fontSize: '12px',
    fontFamily: 'Inter',
    fontWeight: 500,
    height: 'auto', // Adjust height to auto to fit content
    borderRadius: '4px 0px 0px 0px',
    background: '#ffffff1a',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column', // Ensure vertical stacking
    alignItems: 'flex-start', // Align text to the left
    justifyContent: 'center',
    padding: '10px' // Added padding for better spacing
  };

  return (
    <div style={pageStyle}>
     <Navbar 
        onButtonClick={handleNavbarButtonClick} 
        onFileUpload={handleNavbarFileUpload} 
      /> {/* Include Navbar component */}
      <div style={opportunitiesStyle}>
        <div>No of opportunities: {opportunities}</div>
        <div>Customer names: {customerNames.join(', ')}</div>
        <div>Opportunity names: {opportunityNames.join(', ')}</div>
      </div>
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
        </div>
      )}
      <div style={containerStyle}>
        <div style={messagesContainerStyle}>
          {renderMessages()}
          <div ref={messagesEndRef} />
        </div>
        <div style={inputContainerStyle}>
          <input
            type="file"
            id="file-upload"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
          <button style={clipButtonStyle} onClick={() => document.getElementById('file-upload').click()}>
            <img src="/images/clip.png" alt="Clip" style={{ width: '30px', height: '30px' }} />
          </button>
          <input
            type="text"
            placeholder="Ask any question..."
            value={inputValue}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            style={inputStyle}
            ref={inputRef}
          />
          <button onClick={handleSendMessage} style={buttonStyle} disabled={isSending || isLoading}>
            <img src="/images/send.png" alt="Send" style={{ width: '30px', height: '30px' }} />
          </button>
        </div>
      </div>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Chatbot;

// CSS for loading spinner and overlay
const loadingOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const loadingSpinnerStyle = {
  width: '50px',
  height: '50px',
  border: '5px solid rgba(255, 255, 255, 0.3)',
  borderTop: '5px solid #fff',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
};

const styles = document.createElement('style');
styles.innerHTML = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .loading-overlay {
    ${Object.entries(loadingOverlayStyle).map(([key, value]) => key + ': ' + value + ';').join(' ')}
  }

  .loading-spinner {
    ${Object.entries(loadingSpinnerStyle).map(([key, value]) => key + ': ' + value + ';').join(' ')}
  }

  @media (max-width: 600px) {
    .pageStyle {
      padding: 14px 10px;
    }
    .inputContainerStyle {
      width: calc(100% - 20px);
    }
    .buttonStyle {
      margin-left: 5px;
    }
  }
`;

document.head.appendChild(styles);
